import React from "react";
import { getTranslate } from "react-localize-redux";
import { connect } from "react-redux";

import Section from "../../components/section/section";
import Panel from "../../components/panel/panel";

@connect(({ localize, lenderStatistic: { summary } }) => ({
  translate: getTranslate(localize),
}))
class LoanSummary extends React.Component {
  render() {
    const { translate, summary } = this.props;
    return (
      <Section className="application-summary">
        {/* <Panel
          className="active-loan"
          title={translate("loanSummary.ovo_admin_label_active_loans")}
        >
          <h1>{summary && numeral(summary.cycle_fund).format(moneyFormat)}</h1>
        </Panel> */}
        <Panel
          className="closed"
          title={translate("loanSummary.ovo_admin_label_disbursed_loans")}
        >
          <h1>{summary.loans_approved.number_of_loans}</h1>
        </Panel>
      </Section>
    );
  }
}

export default LoanSummary;
